import { ClassAttributes, HTMLAttributes, useContext, useEffect, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { useMutation, useQuery, useQueryClient} from "react-query";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../Provider";
import UpdateServiceModal from "../../components/ModalUpdateService";
import { httpDELETE, httpGET } from "../../utils/ajaxHelper";
import DeleteConfirmModal from "./deleteConfirmModal";
import DeleteSuccessModal from "./deleteSuccess";
import CustomModal from "./modal";
import {
  AGButton,
  AGButtonPrimary,
  AGButtonPrimarySearch,
  AGSearch,
  AGSelect,
  ButtonContainer,
  Container,
  InputContainer,
  InputLabel,
  InputSearch,
  Result,
  SearchContainer,
  Tab,
  Title,
  TitleRow,
} from "./style";
import UpdateProductModal from "../../components/ModalUpdateProduct";
import UpdateSecondmentModal from "../../components/ModalUpdateSecondment";
import StickyContainer from "../../components/StickyContainer";
import { CustomScroll } from "../inquiryManagement/inquiryManagement.styled";
import PageInfiniteScroll from "../../components/PageInfiniteScroll";
import { ADMIN_ORGANIZATION } from "../../utils/constant";
import { SORT_FIELDS_ORG_ADMIN } from "../../utils/constant";
import { ArrowDownIcon } from "../../assets/svg/arrowDown";
import { ArrowUpIcon } from "../../assets/svg/arrowUp";
import { ArrowDownGrayIcon } from "../../assets/svg/arrowDownGrayIcon";
import { PageContainerContext} from "../../Provider";

const DropdownIndicatorLocation = (props: {
  innerProps: JSX.IntrinsicAttributes &
  ClassAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement>;
}) => {
  return (
    <div {...props.innerProps}>
      <LocationIcon />
    </div>
  );
};

const customSelectStyles = {
  dropdownIndicator: () => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "100%",
  }),
};

const LocationIcon = () => {
  return (
    <svg
      version="1.1"
      id="_x32_"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      fill="rgb(39, 129, 186)"
      width="17"
      height="17"
      style={{
        marginRight: 10,
      }}
    >
      <g
        id="SVGRepo_bgCarrier"
        strokeWidth="0"
      ></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <path
            className="st0"
            d="M256,0C159.969,0,82.125,77.859,82.125,173.906C82.125,269.938,236.797,512,256,512 c19.219,0,173.875-242.063,173.875-338.094C429.875,77.859,352.031,0,256,0z M256,240.406c-36.719,0-66.5-29.781-66.5-66.5 c0-36.75,29.781-66.531,66.5-66.531s66.516,29.781,66.516,66.531C322.516,210.625,292.719,240.406,256,240.406z"
          ></path>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

const SearchIcon = () => {
  return (
    <svg
      fill="rgb(39, 129, 186)"
      width="151px"
      height="151px"
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
      stroke="rgb(39, 129, 186)"
      style={{ marginRight: 10 }}
    >
      <g
        id="SVGRepo_bgCarrier"
        strokeWidth="0"
      ></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M790.588 1468.235c-373.722 0-677.647-303.924-677.647-677.647 0-373.722 303.925-677.647 677.647-677.647 373.723 0 677.647 303.925 677.647 677.647 0 373.723-303.924 677.647-677.647 677.647Zm596.781-160.715c120.396-138.692 193.807-319.285 193.807-516.932C1581.176 354.748 1226.428 0 790.588 0S0 354.748 0 790.588s354.748 790.588 790.588 790.588c197.647 0 378.24-73.411 516.932-193.807l516.028 516.142 79.963-79.963-516.142-516.028Z"
          fillRule="evenodd"
        ></path>{" "}
      </g>
    </svg>
  );
};

const FirmManagement = () => {
  const [serviceId, setServiceId] = useState<number | undefined>(undefined);
  const [searchParams, setSearchParams] = useState({
    firmName: "",
    locations: [],
    pageNumber: 1,
    sortField: SORT_FIELDS_ORG_ADMIN.ORGANIZATION_NAME,
    sortOrder: 1
  });

  const [openModal, setOpenModal] = useState(false);
  const [selectedFirm, setSelectedFirm] = useState("");
  const [showModal, setShowModal] = useState<string | undefined>();
  const [firmWithServices, setFirmWithServices] = useState<any>(undefined);
  const [updatedFirmInfo, setUpdatedFirmInfo] = useState<any>(undefined);

  const getLocation = async () => {
    const data = await httpGET({
      url: "/agnetregion",
    });
    return data;
  };

  const { data: location } = useQuery(["getLocation"], getLocation);
  const [deleteSuccess, setDeleteSuccess] = useState(false);

  const toggleModal = () => setOpenModal(!openModal);
  const toggleDeleteSuccess = () => setDeleteSuccess(!deleteSuccess);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openConfirmDeleteService, setOpenConfirmDeleteService] = useState(false);
  const [isDeletedFromPopup, setIsDeletedFromPopup] = useState(false);

  const toggleOpenConfirm = () => setOpenConfirm(!openConfirm);
  const toggleOpenServiceConfirm = () => setOpenConfirmDeleteService(!openConfirmDeleteService);
  const queryClient = useQueryClient();

  const [sortParam, setSortParam] = useState({
      field: SORT_FIELDS_ORG_ADMIN.ORGANIZATION_NAME,
      order: 1
  });

  const [handleText, setHandleText] = useState("");

  const { mutate: deleteFirmService } = useMutation(
    (firmId: string) =>
      httpDELETE({
        url: "/ExpertiseService/delete-firm-services",
        params: {
          firmId: firmId,
          pageNumber: searchParams?.pageNumber ?? 1,
          firmName: searchParams?.firmName ?? null,
          locations: searchParams.locations.map((item: any) => item?.value).join(","),
          sortField: searchParams?.sortField,
          sortOrder: searchParams?.sortOrder
        }
      }),
    {
      onSuccess: (rs) => {
        setFirmWithServices((prev: any) => ({
          ...prev,
          maxLength: prev.maxLength - 1,
          data: prev.data.filter((x: any) => x.firmId !== rs.deletedId)
        }));
        if (rs.appendedItem !== null) {
          setFirmWithServices((prev: any) => ({
            ...prev,
            data: [...(prev.data || []), rs.appendedItem]
          }));
        }
        if (!isDeletedFromPopup){
          toggleDeleteSuccess();
          setServiceId(undefined);
          setHandleText(handleTextByOfferingTypeID(4));
        }
      },
    },
  );

  const { mutate: deleteService } = useMutation(
    (firmId: string) =>
      httpDELETE({
        url: "/CommerceFirmData/delete?id=" + serviceId,
      }),
    {
      onSuccess: (rs) => {
        queryClient.invalidateQueries(["getFirms", "getServices"]);
        toggleDeleteSuccess();
        setServiceId(undefined);
        getFirmByService(String(serviceId));
      }
    })

  const { mutate: getFirmWithService } = useMutation(
    () =>
      httpGET({
        url: "/firm/firm-with-services",
        params: {
          pageNumber: searchParams?.pageNumber ?? 1,
          firmName: searchParams?.firmName ?? null,
          locations: searchParams?.locations?.map((item: any) => item?.value).join(","),
          sortField: searchParams?.sortField,
          sortOrder: searchParams?.sortOrder
        }
      }),
    {
      onSuccess: (rs) => {
        if (searchParams.pageNumber < 2) {
          setFirmWithServices(rs);
      } else {
        setFirmWithServices((prev: any) => ({
          ...rs, // replace pagination and metadata
          data: [...(prev.data || []), ...rs.data] // append data
        }));
      }
      },
    },
  );

  const { mutate: getFirmByService } = useMutation(
    (serviceId: string) =>
      httpGET({
        url: `/firm/firm-by-service?serviceId=${serviceId}`
      }),
    {
      onSuccess: (rs: any) => {
        if (rs.countServices === 0 && rs.countProducts === 0 && rs.countSecondments === 0){
          deleteFirmService(rs.firmId);
        }else{
          setFirmWithServices((prev: any) => ({
            ...prev,
            data: prev.data.map((item: any) =>
              item.firmId === rs.firmId ? { ...rs } : item
            )
          }));
        }
      },
    },
  );

  const navigate = useNavigate();
  const user = useContext(UserContext);
  const [publishCompeled, setPublishCompleted] = useState(false);
  const [deleteCompeled, setDeleteCompleted] = useState(false);

  useEffect(() => {
    if (user && user.individual.fkOrgId !== ADMIN_ORGANIZATION.ID) {
      navigate("/");
    }
  }, [navigate, user]);

  useEffect(() => {
    getFirmWithService();
  }, [getFirmWithService, searchParams])

  const handleState = (offeringTypeID: number, type: string) => {
    if (type === "update") {
      switch (offeringTypeID) {
        case 1:
          return "EditService";
        case 2:
          return "EditProduct";
        case 3:
          return "EditSecondment";
        default:
          return undefined;
      }
    } else if (type === "delete") {
      switch (offeringTypeID) {
        case 1:
          return "DeleteService";
        case 2:
          return "DeleteProduct";
        case 3:
          return "DeleteSecondment";
        default:
          return undefined;
      }
    }
  };

  const handleTextByOfferingTypeID = (id: number) => {
    switch (id) {
      case 1:
        return "service";
      case 2:
        return "product";
      case 3:
        return "secondment";
      case 4:
        return "offering";
      default:
        return "";
    }
  };

  const pageContainerDivRef = useContext(PageContainerContext)
  const movePageToTop = ()=>{
        pageContainerDivRef?.current?.scrollTo({ top: 0, behavior: "auto" });
    }

  return (
    <Container>
      {serviceId && (
        <UpdateServiceModal
          visible={showModal === "EditService"}
          toggleModal={() => {
            setServiceId(undefined);
          }}
          id={`${serviceId}`}
          publishComplete={() => {
            setServiceId(undefined);
            setPublishCompleted(!publishCompeled);
          }}
          onDeleteService={() => {
            setOpenConfirmDeleteService(!openConfirmDeleteService);
            setDeleteCompleted(!deleteCompeled);
          }}
          toggleError={() => {
            setServiceId(undefined);
          }}
          onEditSuccess={(rs: any)=>{
						  setUpdatedFirmInfo(rs);
          }}
        />
      )}

      {serviceId && (
        <>
          <UpdateProductModal
            publishComplete={() => {
              setServiceId(undefined);
              setPublishCompleted(!publishCompeled);
            }}
            visible={showModal === "EditProduct"}
            toggleModal={() => {
              setShowModal(undefined);
            }}
            toggleError={() => {
              setShowModal(undefined);
            }}
            id={serviceId.toString()}
            onDeleteService={(e) => {
              setOpenConfirmDeleteService(!openConfirmDeleteService);
              setDeleteCompleted(!deleteCompeled);
            }}
            initSearchParams={searchParams}
            onEditSuccess={(rs: any)=>{
						  setUpdatedFirmInfo(rs);
            }}
          />
        </>
      )}
      {serviceId && (
        <>
          <UpdateSecondmentModal
            publishComplete={() => {
              setServiceId(undefined);
              setPublishCompleted(!publishCompeled);
            }}
            visible={showModal === "EditSecondment"}
            toggleModal={() => {
              setShowModal(undefined);
            }}
            toggleError={() => {
              setShowModal(undefined);
            }}
            offeringId={serviceId?.toString() ?? ""}
            onDeleteService={(e) => {
              setOpenConfirmDeleteService(!openConfirmDeleteService);
              setDeleteCompleted(!deleteCompeled);
            }}
            organizationId={Number(selectedFirm)}
            initSearchParams={searchParams}
            onEditSuccess={(rs: any)=>{
						  setUpdatedFirmInfo(rs);
            }}
          />
        </>
      )}

      <DeleteSuccessModal
        visible={deleteSuccess}
        toggleModal={toggleDeleteSuccess}
        text={handleText}
      />

      {/* delete firm services */}
      <DeleteConfirmModal
        visible={openConfirm}
        toggleModal={toggleOpenConfirm}
        selectedService={selectedFirm}
        deleteService={deleteFirmService}
        type={1}
        text=""
      />

      {/* delete service */}
      <DeleteConfirmModal
        visible={openConfirmDeleteService}
        toggleModal={toggleOpenServiceConfirm}
        selectedService={serviceId?.toString() || ""}
        deleteService={deleteService}
        deletedService={() => {
          setDeleteCompleted(!deleteCompeled);
        }}
        type={2}
        text={handleText}
      />

      {
        <CustomModal
          visible={openModal}
          toggleModal={()=>{
            setIsDeletedFromPopup(false);
            toggleModal();
          }}
          selectedFirm={selectedFirm}
          setServiceId={(e, f) => {
            setServiceId(e);
            setShowModal(handleState(f, "update"));
            setHandleText(handleTextByOfferingTypeID(f));
          }}
          publishCompleted={publishCompeled}
          deleteServiceCompeleted={deleteCompeled}
          updateFirmList={(selectedService) => {
            getFirmByService(selectedService);
          }}
          resetSelectedFirm={()=>{setSelectedFirm("")}}
          updatedFirmInfo={updatedFirmInfo}
        />
      }
      <StickyContainer top={70}>
        <div className="flex mb-6 border-gray-300 border w-fit	rounded p-3 bg-white">
          {/* <Tab
					onClick={() => {
						navigate("/");
					}}>
					Marketplace
				</Tab> */}

          <Tab>
            <Link to="/dashboard-admin">Admin Dashboard</Link>
          </Tab>
          <Tab>
            <Link to="/inquiry-management">Inquiries Management</Link>
          </Tab>
          <Tab className="active">Organizations Management</Tab>
          <Tab>
            <Link to="/admin-service-management">Offerings Management</Link>
          </Tab>
        </div>

        <SearchContainer>
          <TitleRow>
            <Title> Organizations Management</Title>
          </TitleRow>
          <InputContainer>
            <InputLabel>Search Organization Name</InputLabel>
            <InputSearch>
              <AGSearch
                placeholder="Search a name or keywords"
                value={searchParams.firmName}
                onChange={(e) =>
                  {
                    movePageToTop();
                    setSearchParams({
                    ...searchParams,
                    pageNumber: 1,
                    firmName: e.target?.value,
                  })
                  }
                }
              />
              <SearchIcon />
            </InputSearch>
          </InputContainer>

          <InputContainer>
            <InputLabel>Region</InputLabel>
            <AGSelect
              className="custom-select"
              options={location?.map((item: any) => ({
                value: item?.netRegionId,
                label: item?.netRegionName,
              }))}
              placeholder="Select region"
              isMulti={true}
              value={searchParams.locations}
              onChange={(options: any) =>
                {
                  movePageToTop();
                  setSearchParams({
                    ...searchParams,
                    pageNumber: 1,
                    locations: options,
                  })
                }
              }
              isClearable
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  boxShadow: "none",
                  borderColor: state.isFocused ? "rgb(39, 129, 186)" : "gray",
                  "&:hover": {borderColor: "rgb(39, 129, 186)"},
                }),
                ...customSelectStyles,
                indicatorSeparator: () => ({
                  display: "none",
                }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? "rgb(31, 103, 149)" : "white",
                  color: state.isFocused ? "white" : "",
                  minHeight: 36,
                  fontSize: 13.5,
                  cursor: "pointer",
                  ":hover": {
                    backgroundColor: "rgb(31, 103, 149)",
                    color: "white",
                  },
                }),
                placeholder: (base) => ({
                    ...base,
                    color: 'rgb(99, 115, 129)'
                }),
                singleValue: (base) => ({
                    ...base,
                    color: 'rgb(0, 0, 0)',
                }),               
              }}
              components={{
                DropdownIndicator: DropdownIndicatorLocation,
              }}
              filterOption={(option, inputValue) => {
                return option.label?.toLowerCase().includes(inputValue?.toLowerCase());
              }}
            />
          </InputContainer>
          <ButtonContainer>
            <AGButtonPrimarySearch
              disabled={searchParams.firmName === "" && searchParams.locations.length === 0}
              onClick={() =>
                {
                  movePageToTop();
                  setSearchParams({
                    firmName: "",
                    locations: [],
                    pageNumber: 1,
                    sortField: SORT_FIELDS_ORG_ADMIN.ORGANIZATION_NAME,
                    sortOrder: 1
                  })
                }
              }
            >
              Clear search
            </AGButtonPrimarySearch>
          </ButtonContainer>
        </SearchContainer>

        <Result>Search results: ({firmWithServices?.maxLength}) </Result>
        <div className=" flex items-center  rounded-lg bg-white">
          <div
          onClick={() =>{
              movePageToTop();
              if (sortParam.field !== SORT_FIELDS_ORG_ADMIN.ORGANIZATION_NAME){
                setSortParam({
                  ...sortParam,
                  order: 0,
                  field: SORT_FIELDS_ORG_ADMIN.ORGANIZATION_NAME,
                });
                setSearchParams({
                    ...searchParams,
                    sortOrder: 0,
                    sortField: SORT_FIELDS_ORG_ADMIN.ORGANIZATION_NAME,
                    pageNumber: 1
                })
              }else{
                setSortParam({
                  ...sortParam,
                  order: sortParam.order === 1 ? 0 : 1,
                  field: SORT_FIELDS_ORG_ADMIN.ORGANIZATION_NAME,
                });
                setSearchParams({
                    ...searchParams,
                    sortOrder: sortParam.order === 1 ? 0 : 1,
                    sortField: SORT_FIELDS_ORG_ADMIN.ORGANIZATION_NAME,
                    pageNumber: 1
                })
              }
          }}
          className="h-10 flex-[4] text-[14px] text-submit border-solid border border-light-gray-200 py-2 px-2  font-bold ">
            Organization Name &nbsp;{" "}
            {sortParam.field === SORT_FIELDS_ORG_ADMIN.ORGANIZATION_NAME &&
              sortParam.order === 0 && (
                <ArrowUpIcon/>
              )}
            {sortParam.field === SORT_FIELDS_ORG_ADMIN.ORGANIZATION_NAME &&
              sortParam.order === 1 && (
                <ArrowDownIcon/>
              )}
            {sortParam.field !== SORT_FIELDS_ORG_ADMIN.ORGANIZATION_NAME && (
              <ArrowDownGrayIcon/>
            )}
          </div>
          <div
          onClick={() =>{
              movePageToTop();
              if (sortParam.field !== SORT_FIELDS_ORG_ADMIN.REGION){
                setSortParam({
                  ...sortParam,
                  order: 0,
                  field: SORT_FIELDS_ORG_ADMIN.REGION,
                });
                setSearchParams({
                    ...searchParams,
                    sortOrder: 0,
                    sortField: SORT_FIELDS_ORG_ADMIN.REGION,
                    pageNumber: 1
                })
              }else{
                setSortParam({
                  ...sortParam,
                  order: sortParam.order === 1 ? 0 : 1,
                  field: SORT_FIELDS_ORG_ADMIN.REGION,
                });
                setSearchParams({
                    ...searchParams,
                    sortOrder: sortParam.order === 1 ? 0 : 1,
                    sortField: SORT_FIELDS_ORG_ADMIN.REGION,
                    pageNumber: 1
                })
              }
          }}
          className="h-10 flex-[2.2] text-[14px] border border-light-gray-200 py-2 px-2  font-bold ">
            Region &nbsp;{" "}
            {sortParam.field === SORT_FIELDS_ORG_ADMIN.REGION &&
              sortParam.order === 0 && (
                <ArrowUpIcon/>
              )}
            {sortParam.field === SORT_FIELDS_ORG_ADMIN.REGION &&
              sortParam.order === 1 && (
                <ArrowDownIcon/>
              )}
            {sortParam.field !== SORT_FIELDS_ORG_ADMIN.REGION && (
              <ArrowDownGrayIcon/>
            )}
          </div>
          <div
          onClick={() =>{
              movePageToTop();
              if (sortParam.field !== SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SERVICES){
                setSortParam({
                  ...sortParam,
                  order: 0,
                  field: SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SERVICES,
                });
                setSearchParams({
                    ...searchParams,
                    sortOrder: 0,
                    sortField: SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SERVICES,
                    pageNumber: 1
                })
              }else{
                setSortParam({
                  ...sortParam,
                  order: sortParam.order === 1 ? 0 : 1,
                  field: SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SERVICES,
                });
                setSearchParams({
                    ...searchParams,
                    sortOrder: sortParam.order === 1 ? 0 : 1,
                    sortField: SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SERVICES,
                    pageNumber: 1
                })
              }
          }}
          className="h-10 flex-[2.2] text-[14px] text-submit border-solid border border-light-gray-200 py-2 px-2  font-bold ">
            Number of Services &nbsp;{" "}
            {sortParam.field === SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SERVICES &&
              sortParam.order === 0 && (
                <ArrowUpIcon/>
              )}
            {sortParam.field === SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SERVICES &&
              sortParam.order === 1 && (
                <ArrowDownIcon/>
              )}
            {sortParam.field !== SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SERVICES && (
              <ArrowDownGrayIcon/>
            )}
          </div>
          <div
          onClick={() =>{
              movePageToTop();
              if (sortParam.field !== SORT_FIELDS_ORG_ADMIN.NUMBER_OF_PRODUCTS){
                setSortParam({
                  ...sortParam,
                  order: 0,
                  field: SORT_FIELDS_ORG_ADMIN.NUMBER_OF_PRODUCTS,
                });
                setSearchParams({
                    ...searchParams,
                    sortOrder: 0,
                    sortField: SORT_FIELDS_ORG_ADMIN.NUMBER_OF_PRODUCTS,
                    pageNumber: 1
                })
              }else{
                setSortParam({
                  ...sortParam,
                  order: sortParam.order === 1 ? 0 : 1,
                  field: SORT_FIELDS_ORG_ADMIN.NUMBER_OF_PRODUCTS,
                });
                setSearchParams({
                    ...searchParams,
                    sortOrder: sortParam.order === 1 ? 0 : 1,
                    sortField: SORT_FIELDS_ORG_ADMIN.NUMBER_OF_PRODUCTS,
                    pageNumber: 1
                })
              }
          }}
          className="h-10 flex-[2.2] text-[14px] text-submit border-solid border border-light-gray-200 py-2 px-2  font-bold ">
            Number of Products &nbsp;{" "}
            {sortParam.field === SORT_FIELDS_ORG_ADMIN.NUMBER_OF_PRODUCTS &&
              sortParam.order === 0 && (
                <ArrowUpIcon/>
              )}
            {sortParam.field === SORT_FIELDS_ORG_ADMIN.NUMBER_OF_PRODUCTS &&
              sortParam.order === 1 && (
                <ArrowDownIcon/>
              )}
            {sortParam.field !== SORT_FIELDS_ORG_ADMIN.NUMBER_OF_PRODUCTS && (
              <ArrowDownGrayIcon/>
            )}
          </div>
          <div
          onClick={() =>{
              movePageToTop();
              if (sortParam.field !== SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SECONDMENTS){
                setSortParam({
                  ...sortParam,
                  order: 0,
                  field: SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SECONDMENTS,
                });
                setSearchParams({
                    ...searchParams,
                    sortOrder: 0,
                    sortField: SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SECONDMENTS,
                    pageNumber: 1
                })
              }else{
                setSortParam({
                  ...sortParam,
                  order: sortParam.order === 1 ? 0 : 1,
                  field: SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SECONDMENTS,
                });
                setSearchParams({
                    ...searchParams,
                    sortOrder: sortParam.order === 1 ? 0 : 1,
                    sortField: SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SECONDMENTS,
                    pageNumber: 1
                })
              }
          }}
          className="h-10 flex-[2.2] text-[14px] text-submit border-solid border border-light-gray-200 py-2 px-2  font-bold ">
            Number of Secondments &nbsp;{" "}
            {sortParam.field === SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SECONDMENTS &&
              sortParam.order === 0 && (
                <ArrowUpIcon/>
              )}
            {sortParam.field === SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SECONDMENTS &&
              sortParam.order === 1 && (
                <ArrowDownIcon/>
              )}
            {sortParam.field !== SORT_FIELDS_ORG_ADMIN.NUMBER_OF_SECONDMENTS && (
              <ArrowDownGrayIcon/>
            )}
          </div>
          <div className="h-10 flex-[1.6] text-[14px] border-y border-r border-light-gray-200 py-2 px-2  font-bold ">
            Offering's Action
          </div>
        </div>
      </StickyContainer>
      <CustomScroll style={{minHeight: "72vh"}}>
        <PageInfiniteScroll
          items={firmWithServices?.data ?? []}
          hasMore={
            firmWithServices
              ? firmWithServices.data.length < (firmWithServices.maxLength as number)
              : false
          }
          loadMore={() => {
            const currentPage = searchParams.pageNumber ?? 0;
            setSearchParams({...searchParams, pageNumber: currentPage + 1});
          }}
          renderItem={(firm: any, index, onClick, onSelect) => (
            <div
              className="flex items-center rounded-lg bg-white"
              key={firm.firmId}
            >
              <div className="h-10 flex-[4] text-[14px] text-submit border-solid border border-light-gray-200 py-2 px-2">
                <p className="line-clamp-1" title={firm.firmName1}>{firm.firmName1}</p>
              </div>
              <div className="h-10 flex-[2.2] text-[14px] border-solid border border-light-gray-200 py-2 px-2  ">
                {firm.netRegionName}
              </div>
              <div className="h-10 flex-[2.2] text-[14px] text-submit border-solid border border-light-gray-200 py-2 px-2  ">
                {firm.countServices}
              </div>
              <div className="h-10 flex-[2.2] text-[14px] text-submit border-solid border border-light-gray-200 py-2 px-2  ">
                {firm.countProducts}
              </div>
              <div className="h-10 flex-[2.2] text-[14px] text-submit border-solid border border-light-gray-200 py-2 px-2  ">
                {firm.countSecondments}
              </div>
              <div className="h-10 flex-[1.6] text-[14px] text-submit border-solid border-y border-r border-light-gray-200 py-2 px-2 justify-center flex items-center">
                <AGButtonPrimary
                  onClick={() => {
                    setIsDeletedFromPopup(true);
                    toggleModal();
                    setSelectedFirm(firm.firmId);
                  }}
                >
                  View
                </AGButtonPrimary>
                <AGButton
                  onClick={() => {
                    toggleOpenConfirm();
                    setSelectedFirm(firm.firmId);
                  }}
                  style={{background: "#D9D9D9 "}}
                >
                  Delete
                </AGButton>
              </div>
            </div>
          )}
        />
      </CustomScroll>
    </Container>
  );
};

export default FirmManagement;
